import * as React from 'react';

import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import { useMobileWebConversationalDiscoveryExperiment } from 'bundles/unified-common/contexts/MobileWebConversationalDiscoveryExperimentContext';

// The mobile-web conversational-discovery treatment removes the logo from the nav bar entirely
// (design decision, MERCH-3449) to free width for the Enroll CTA at narrow viewports -- it does
// not swap to a compact mark. Render null rather than passing empty logos to
// HomeLogoGridItemModule: that component always emits its link/wrapper chrome, so an empty logo
// would leave a zero-width but still-focusable "Coursera" link in the tab order.
const MobileNavBarLogo = (props: React.ComponentProps<typeof HomeLogoGridItemModule>) => {
  const { mobileWebConversationalDiscoveryEnabled } = useMobileWebConversationalDiscoveryExperiment();
  return mobileWebConversationalDiscoveryEnabled ? null : <HomeLogoGridItemModule {...props} />;
};

export default MobileNavBarLogo;
